/*
 * vp-pending-cart — storefront half of the quiz → website cart handoff.
 *
 * The quiz (quiz.<apex>) writes a short-lived first-party cookie `vp_pending_cart`
 * scoped to the shared apex (e.g. .vitapack.cz) holding the recommended pack
 * (variant ids + selling plans + the gift discount code). This snippet runs on
 * the Shopify online store (<apex>) and, the FIRST time a buyer lands with that
 * cookie present, REPLACES the cart with the pack via the Ajax API — so a buyer
 * who clicks the logo in checkout finds their recommendation already in the cart.
 *
 * Why the Ajax API and not a cart permalink: permalinks can't carry subscription
 * selling plans; /cart/add.js can. The free-forever product stays free because
 * its price lives in the selling plan (carried here). The gift water bottle is
 * zeroed by the discount code, which we apply on the storefront too.
 *
 * Install: see shopify-theme/README.md. Safe to run site-wide — it's a no-op
 * (one cookie read) for every visitor without a fresh note.
 */
(function () {
  "use strict";

  var COOKIE = "vp_pending_cart";

  function readCookie(name) {
    var re = new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, "\\$1") + "=([^;]*)");
    var m = document.cookie.match(re);
    return m ? m[1] : null;
  }

  // Delete on the shared apex (".apex.tld" = last two labels) AND host-scoped,
  // so a refresh / second tab can't replay it. Must match the write's Domain.
  function deleteCookie(name) {
    var labels = location.hostname.split(".");
    var apex = "." + labels.slice(-2).join(".");
    document.cookie = name + "=; Max-Age=0; Path=/; Domain=" + apex;
    document.cookie = name + "=; Max-Age=0; Path=/";
  }

  function b64decode(v) {
    try {
      return decodeURIComponent(escape(atob(v)));
    } catch (e) {
      try { return atob(v); } catch (e2) { return null; }
    }
  }

  var raw = readCookie(COOKIE);
  if (!raw) return;

  // Consume immediately — before any async work — so a refresh mid-rebuild or a
  // second tab never double-applies. (Trade-off: a network failure after the
  // clear leaves an empty cart; rare for a same-origin POST. See README.)
  deleteCookie(COOKIE);

  var data;
  try { data = JSON.parse(b64decode(raw) || ""); } catch (e) { return; }
  if (!data || !Array.isArray(data.items) || !data.items.length) return;

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
      credentials: "same-origin",
    });
  }

  function safeRedirectPath() {
    // Stay on the current page after applying the discount; only allow same-site paths.
    var p = location.pathname + location.search;
    return p.charAt(0) === "/" ? p : "/";
  }

  // 1) empty whatever's there (previous session / previous quiz run)
  // 2) add the fresh pack (with selling plans + gift line properties)
  // 3) apply the gift discount code(s) so the gift line zeroes (carries to checkout too)
  // 4) reflect it in the UI (the discount nav reloads; otherwise reload once)
  postJSON("/cart/clear.js", {})
    .then(function () {
      return postJSON("/cart/add.js", { items: data.items });
    })
    .then(function (r) {
      if (!r.ok) throw new Error("vp-pending-cart: add failed " + r.status);
      var codes = (data.discounts || []).filter(Boolean);
      if (codes.length) {
        // Discount permalink applies the code to the session + checkout, then
        // returns us to where we were with the cart now showing the freebie.
        location.href =
          "/discount/" + codes.map(encodeURIComponent).join(",") +
          "?redirect=" + encodeURIComponent(safeRedirectPath());
      } else {
        // No code: just refresh so the header cart count + drawer update.
        location.reload();
      }
    })
    .catch(function (err) {
      if (window.console && console.warn) console.warn(err);
      /* best-effort: leave the cart as-is */
    });
})();
